import { render, staticRenderFns } from "./videoRooms.vue?vue&type=template&id=b48e036c&scoped=true"
import script from "./videoRooms.vue?vue&type=script&lang=js"
export * from "./videoRooms.vue?vue&type=script&lang=js"
import style0 from "./videoRooms.vue?vue&type=style&index=0&id=b48e036c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e036c",
  null
  
)

export default component.exports